import { useTheme, useMediaQuery } from '@mui/material';
import DocumentiListPageDesktop from './DocumentiListPageDesktop';
import DocumentiListPageMobile from './DocumentiListPageMobile';

export default function DocumentiListPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <DocumentiListPageMobile />
    : <DocumentiListPageDesktop />;
}